import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import storageSession from 'redux-persist/lib/storage/session'
import {persistStore, persistCombineReducers} from 'redux-persist'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import ApplicationReducer from "./reducers/ApplicationReducer";

const persistConfig = {
    key: 'root',
    storage: storageSession,
    stateReconciler: hardSet
}

const applicationReducers = {
    application: ApplicationReducer,
}

const persistCombinedReducers = persistCombineReducers(persistConfig, applicationReducers)

const configureStore = () => {
    const store = createStore(persistCombinedReducers, applyMiddleware(thunk))
    const persistor = persistStore(store)
    return {store, persistor};
};

export default configureStore